import interpolate from '@/lib/interpolate';
import { parseDatasetJson } from '@/lib/dataset_json';

let alternativeCount = 0;

export function nextAlternativeId() {
  alternativeCount += 1;

  return `map-alternative-${alternativeCount}`;
}

export function parseA11yLabels(dataset, context) {
  return parseDatasetJson(dataset.a11y, context);
}

export function pluralize(forms, count, values = {}) {
  const { zero, one, other } = forms || {};
  const template = (count === 0 && zero) || (count === 1 && one) || other;

  return interpolate(template, { count, ...values });
}

// A missing label leaves either a nameless application region or, worse, a control the
// region made necessary with no accessible name at all: report it rather than ship it.
export function reportMissingLabels(labels, keys, context) {
  const missing = keys.filter(
    key => !key.split('.').reduce((value, part) => value?.[part], labels),
  );

  if (missing.length === 0) return;

  if (window.Sentry) {
    window.Sentry.captureMessage('Missing accessibility labels', {
      level: 'warning',
      extra: { context, missing },
    });
  }
}
